var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack194({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.38,8.53l.1-.49h1.88L15,9.79a3.37,3.37,0,0,1-.81.37,3.11,3.11,0,0,1-.89.14,1.7,1.7,0,0,1-1.4-.57A1.89,1.89,0,0,1,11.5,8.5a2.87,2.87,0,0,1,.34-1.4,2.33,2.33,0,0,1,.86-.94,2.28,2.28,0,0,1,1.16-.3,2,2,0,0,1,.82.16,1.39,1.39,0,0,1,.56.44,2,2,0,0,1,.27.73L15,7.25a1.19,1.19,0,0,0-.37-.68,1.13,1.13,0,0,0-.74-.24,1.61,1.61,0,0,0-.87.26,1.73,1.73,0,0,0-.64.76,2.57,2.57,0,0,0-.25,1.16,1.36,1.36,0,0,0,.32,1,1.18,1.18,0,0,0,.88.33,2.41,2.41,0,0,0,1.21-.37l.19-.92Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5,
    cy: 8,
    r: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack194);
export default __webpack_public_path__ + "static/media/Symbolpack_1_94.d31961f84314a1c91cc444d3bd07122d.svg";
export { ForwardRef as ReactComponent };